
export enum StatusTicketEnum {
    BACKLOG = "BACKLOG",
    EM_ANALISE = "EM_ANALISE",
    EM_DESENVOLVIMENTO = "EM_DESENVOLVIMENTO",
    EM_HOMOLOGACAO = "EM_HOMOLOGACAO",
    AGUARNDANDO_CLIENTE = "AGUARNDANDO_CLIENTE",
    AGUARNDANDO_MERGE = "AGUARNDANDO_MERGE",
    AGUARDANDO_ATUALIZACAO_SISTEMA = "AGUARDANDO_ATUALIZACAO_SISTEMA",
    AGUARDANDO_HOMOLOGACAO_CLIENTE = "AGUARDANDO_HOMOLOGACAO_CLIENTE",
    RESOLVIDO = "RESOLVIDO",
    FINALIZADO_CLIENTE = "FINALIZADO_CLIENTE",
    FINALIZADO_AUTOMATICO = "FINALIZADO_AUTOMATICO",
}

export const DescricaoStatusTicket = new Map<StatusTicketEnum, string>([
    [StatusTicketEnum.EM_ANALISE, "Em Análise"],
    [StatusTicketEnum.EM_DESENVOLVIMENTO, "Em Desenvolvimento"],
    [StatusTicketEnum.EM_HOMOLOGACAO, "Em Homologação"],
    [StatusTicketEnum.AGUARNDANDO_CLIENTE, "Aguardando Cliente"],
    [StatusTicketEnum.AGUARDANDO_ATUALIZACAO_SISTEMA, "Aguardando Atualização do Sistema"],
    [StatusTicketEnum.AGUARDANDO_HOMOLOGACAO_CLIENTE, "Aguardando Homologação do Cliente"],
    [StatusTicketEnum.AGUARNDANDO_MERGE, "Aguardando Merge"],
    [StatusTicketEnum.RESOLVIDO, "Resolvido"],  
    [StatusTicketEnum.FINALIZADO_CLIENTE, "Finalizado pelo Cliente"],
    [StatusTicketEnum.FINALIZADO_AUTOMATICO, "Finalizado Automaticamente"],
    [StatusTicketEnum.BACKLOG, "Backlog"]
]);